<template>
    <div :class="getStatusHeader ? 'notification_popup' : 'notification_popup notification_popup-minimaze'">
        <scrollbar class="wrap">
        <div v-if="lasrOrders !== null" class="notification__zone">
            <div v-for="(item, index) in lasrOrders" :key="index">
                <notification :positionData = "item"></notification>
            </div>
        </div>
        </scrollbar>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import openPositionNoti from "./sig-notification-open-position"
import closePositionNoti from "./sig-notification-close-position"
import notificationItem from "./notificationItem"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { setTimeout } from 'timers';

export default {
    components: {
        'open':openPositionNoti,
        'notification':notificationItem,
        'close':closePositionNoti,
        'scrollbar':VuePerfectScrollbar,
    },
    data() {
        return {
            lasrOrders:null
        }
    },
    computed: {
        ...mapGetters({
            getEvents:'accountevents/events',
            getStatusHeader:'usersets/getHeader'
        }),
        getOpenPosistions() {
            let openPos = []
            for (let i=0; i < this.getEvents.length; i++)
            {
                if(!this.getEvents[i].timeExit) {
                    openPos.push(this.getEvents[i]);
                }
                let obj = {status:true, count:this.getEvents.length}
                this.$emit('bell', obj);
            }
            //this.$emit('bell', true);
            return openPos;
        },
        getClosePosistions() {
            let openClos = []
            for (let i=0; i < this.getEvents.length; i++)
            {
                if(this.getEvents[i].timeExit) {
                    openClos.push(this.getEvents[i]);
                }
                let obj = {status:true, count:this.getEvents.length}
                this.$emit('bell', obj);
            }
            //this.$emit('bell', true);
            return openClos;
        },
        nowDate() {
            let dateNow = new Date()
            return dateNow
        }
    },
    watch: {
       getClosePosistions: function() {
           this.$emit('bellAudio');
       },
       getOpenPosistions: function() {
           this.$emit('bellAudio');
       },
       getEvents: function (newVal, oldVal) {
           this.lasrOrders = newVal.slice(- (newVal.length - oldVal.length));
           this.$emit('lastOrders');
       }
    },
    methods : {
        onClose() {
            this.$emit('close', false)
        }
    }
}
</script>
<style lang="less" scoped>
@keyframes change-top { 
    from {
        top: 96px;
    }
    to {
        top: 48px;
    }
}
@keyframes change-top-full { 
    from {
        top: 48px;
    }
    to {
        top: 96px;
    }
}
.wrap {
    max-height: 100%;
    overflow: auto;
}
.notification_popup {
    height: calc(100vh - 96px);
    width: 454px;
    z-index: 6;
    /*background: #374b62;*/
    position: absolute;
    right: 0;
    top: 96px;
    overflow: hidden;
    &-minimaze {
        animation: change-top 0.6s ease-in 1;
        top: 48px;
        height: calc(100vh - 48px);
    }
}
.notification__sidebar {
    display: flex;
    justify-content: space-between;
    padding: 0 16px 0 12px;
    background-color: #3d536b;
    font-family: Arimo;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 3.64;
    letter-spacing: 0.4px;
    color: #ffffff;
    text-transform: uppercase;
    max-height: 40px;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    &_left-data {
        display: flex;
        justify-content: space-between;
        &-white {
            margin-right: 12px;
        }
        &-gray {
            color: #adc7e1;
            margin-right: 12px;
        }
    }
    &_right-data {
        color: #adc4e1;
        text-transform: none;
        display: flex;
        justify-content: space-between;
        &-date {
            margin-right: 12px;
        }
        &-ico-close {
            font-size: 18px;
            line-height: 1;
            padding-top: 10px;
            cursor: pointer;
        }
    }
}
</style>

